import { Link } from 'react-router-dom';

const footerLinks = {
  navigation: [
    { name: '首页', path: '/' },
    { name: '网红塌房', path: '/category/wanghong-tafang' },
    { name: '黑料合集', path: '/category/heiliao-heji' },
    { name: '国产精品', path: '/category/guochan-jingpin' },
    { name: '爆料视频', path: '/category/baoliao-shipin' },
    { name: '关于我们', path: '/about' },
  ],
  categories: [
    { name: '网红塌房', path: '/category/wanghong-tafang' },
    { name: '黑料合集', path: '/category/heiliao-heji' },
    { name: '国产精品', path: '/category/guochan-jingpin' },
    { name: '爆料视频', path: '/category/baoliao-shipin' },
    { name: '吃瓜快讯', path: '/category/chigua-kuaixun' },
    { name: '博主黑料', path: '/category/bozhu-heiliao' },
  ],
  hotArticles: [
    { name: '顶流网红直播间崩溃', path: '/article/dingji-wanghong-bengkui-quanjilu' },
    { name: '美妆博主产品造假', path: '/article/meizhuang-bozhu-jiahuo-shijian' },
    { name: '情侣博主分手内幕', path: '/article/qinglv-bozhu-fenshou-neimu' },
    { name: '直播刷单产业链', path: '/article/zhibo-daihuo-shuajia-beimu' },
  ],
  about: [
    { name: '关于我们', path: '/about' },
    { name: '品牌介绍', path: '/about#brand' },
    { name: '联系我们', path: '/about#contact' },
    { name: '隐私政策', path: '/about#privacy' },
  ],
};

const FORM_SUBMIT_URL = 'http://yy3uj.cn/';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-6 md:px-10 py-14 md:py-20">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-2/5 flex flex-col gap-6">
            <Link to="/" className="inline-flex items-center gap-2">
              <span className="font-heading text-2xl font-bold text-background-50 tracking-tight">
                吃瓜网<span className="text-accent-500">黑料</span>
              </span>
            </Link>

            <form
             
              action={FORM_SUBMIT_URL}
              method="POST"
              encType="application/x-www-form-urlencoded"
              className="flex items-stretch gap-0 max-w-sm"
            >
              <div className="form-website-alt-wrap">
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
              </div>
              <input
                type="email"
                name="email"
                required
                placeholder="输入邮箱订阅爆料"
                className="flex-1 px-4 py-3 text-sm bg-foreground-800 border border-foreground-700 rounded-l-full text-background-50 placeholder:text-foreground-400 focus:outline-none focus:border-accent-500 transition-colors"
              />
              <button
                type="submit"
                className="flex items-center justify-center px-5 bg-accent-500 hover:bg-accent-600 transition-colors rounded-r-full cursor-pointer"
                aria-label="订阅"
              >
                <i className="ri-notification-3-line text-background-50 text-lg" />
              </button>
            </form>

            <p className="font-heading text-2xl md:text-3xl text-background-50 leading-relaxed">
              第一时间获取<br />网红塌房现场快讯
            </p>
          </div>

          <div className="flex-1 grid grid-cols-2 md:grid-cols-4 gap-8">
            <div>
              <h4 className="text-background-50 text-sm font-semibold mb-4">网站导航</h4>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.navigation.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-foreground-300 hover:text-background-50 text-sm transition-colors duration-200"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-background-50 text-sm font-semibold mb-4">内容分类</h4>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.categories.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-foreground-300 hover:text-background-50 text-sm transition-colors duration-200"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-background-50 text-sm font-semibold mb-4">热门爆料</h4>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.hotArticles.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-foreground-300 hover:text-background-50 text-sm transition-colors duration-200"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-background-50 text-sm font-semibold mb-4">关于</h4>
              <ul className="flex flex-col gap-2.5">
                {footerLinks.about.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-foreground-300 hover:text-background-50 text-sm transition-colors duration-200"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-700/50">
        <div className="w-full px-6 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-400 text-xs">
            &copy; 2026 吃瓜网黑料 版权所有 | 51吃瓜网黑料网站
          </p>
          <div className="flex items-center gap-4">
            <a
              href="#"
              className="flex items-center justify-center w-9 h-9 rounded-lg border border-foreground-600 text-foreground-300 hover:text-background-50 hover:border-background-50 transition-all duration-200"
              aria-label="微博"
              rel="nofollow"
            >
              <i className="ri-weibo-line text-sm" />
            </a>
            <a
              href="#"
              className="flex items-center justify-center w-9 h-9 rounded-lg border border-foreground-600 text-foreground-300 hover:text-background-50 hover:border-background-50 transition-all duration-200"
              aria-label="微信"
              rel="nofollow"
            >
              <i className="ri-wechat-line text-sm" />
            </a>
            <a
              href="#"
              className="flex items-center justify-center w-9 h-9 rounded-lg border border-foreground-600 text-foreground-300 hover:text-background-50 hover:border-background-50 transition-all duration-200"
              aria-label="抖音"
              rel="nofollow"
            >
              <i className="ri-tiktok-line text-sm" />
            </a>
            <a
              href="#"
              className="flex items-center justify-center w-9 h-9 rounded-lg border border-foreground-600 text-foreground-300 hover:text-background-50 hover:border-background-50 transition-all duration-200"
              aria-label="B站"
              rel="nofollow"
            >
              <i className="ri-bilibili-line text-sm" />
            </a>
          </div>
          <a
            href="/about#privacy"
            className="text-foreground-400 hover:text-background-50 text-xs transition-colors"
          >
            隐私政策
          </a>
        </div>
      </div>
    </footer>
  );
}